var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "filter-checkboxes" },
    [
      _vm._l(_vm.filter.options, function (option, index) {
        return [
          _c("input", {
            staticClass: "form-input form__input--checkbox checkbox-style--2",
            attrs: {
              id: "checkbox-" + _vm.filter.name + "-" + index,
              type: "checkbox",
            },
            domProps: { checked: _vm.checked },
            on: {
              click: function ($event) {
                return _vm.select(option)
              },
            },
          }),
          _c("label", {
            attrs: { for: "checkbox-" + _vm.filter.name + "-" + index },
            domProps: { innerHTML: _vm._s(_vm.filter.title) },
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }